import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faStarHalfStroke } from "@fortawesome/free-solid-svg-icons/faStarHalfStroke";

library.add(faStar, faStarHalfStroke);

dom.i2svg();
dom.watch();
